import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
// import p1 from 'assests/Photos/LifeSkill2023/2024/CareerGuidance/1.jpg';
// import p2 from 'assests/Photos/LifeSkill2023/2024/CareerGuidance/2.jpg';
// import p3 from 'assests/Photos/LifeSkill2023/2024/CareerGuidance/3.jpg';
// import p4 from 'assests/Photos/LifeSkill2023/2024/CareerGuidance/4.jpg';
// import p5 from 'assests/Photos/LifeSkill2023/Roadsafty/5.jpg';
// import p6 from 'assests/Photos/LifeSkill2023/Roadsafty/6.jpg';
// import p7 from 'assests/Photos/LifeSkill2023/Roadsafty/7.jpg';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Sidebar2023 from 'views/LifeSkill2023/Sidebar2023';
import Sidebar2025 from '../LifeSkill2023/Sidebar2025';
import Archive2022 from '../LifeSkill2023/Archive2022';

const CareerGuidance2025 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2025: '' });
  
  useEffect(() => {
    fetch('/config.json') // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

  const p1 = `${config.base_image_url_2025}/home/events-activities/life-skill/Career/1.webp`;
  const p2 = `${config.base_image_url_2025}/home/events-activities/life-skill/Career/2.webp`;
  const p3 = `${config.base_image_url_2025}/home/events-activities/life-skill/Career/3.webp`;
  const p4 = `${config.base_image_url_2025}/home/events-activities/life-skill/Career/4.webp`;
  const p5 = `${config.base_image_url_2025}/home/events-activities/life-skill/Career/5.webp`;
  const p6 = `${config.base_image_url_2025}/home/events-activities/life-skill/Career/6.webp`;



  const photos = [
    {
      src: p1,
      source: p1,
      rows: 1.2,
      cols: 1,
    },
    {
      src: p2,
      source:p2,
      rows: 1.2,
      cols: 1,
    },
    {
      src: p3,
      source: p3,
      rows: 1,
      cols: 1,
    },

    {
      src: p4,
      source: p4,
      rows: 1,
      cols: 1,
    },

    {
        src: p5,
        source: p5,
        rows: 1,
        cols: 1,
      },

      {
        src: p6,
        source: p6,
        rows: 1,
        cols: 1,
      },

  ];

  return (
    <Main>
   
<Container>

  <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center' >
       CAREER GUIDANCE
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
      Class: 10,11 & 12	  Date: 12 August 2025
        </Typography>

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        
        National Public School, Yeshwantpur recently organized a structured four-part career guidance programme in collaboration with Lodestar, a career guidance companyfrom 21 July 2025 – 2 August 2025. The initiative was designed to help students and their parents explore career options through self-awareness, aptitude testing and expert guidance. Ms Ramya Pingalay an expertise from Lodestar career guidance was the speaker who addressed the students on Self Exploration and the varied courses available in the market. 
        <br/>
        
        The 2nd session, addressed to parents, was led by Mr. Muralidhar, CEO of Lodestar, an engineer and an entrepreneur. He held a detailed guided presentation to address important topics as the need for scientific career planning in the 21st century, understanding the changing world of careers and new skill sets, problems like stream confusion and oscillating interests during teenage years, Parents’ role in identifying their child’s true interests, rather than pushing based on traditional paths.
        <br/>
        The third session was for students to take up a Psychometric and Aptitude tests that included various topics like Numerical, Verbal, Logical and Spatial reasoning. This final session included students and parents, led by Ms. Ramya. She explained test results in detail and linked them with suitable career clusters, Test validity explanation [The Holland Test; Realistic, Investigative, Artistic, Social, Conventional and Enterprising and what careers come under each personality]
        <br/>
        The 4 sessions held, provided clarity to students, an introspection and all about understanding their interests, strengths and goals so they can figure out what careers might suit them best. This was a beginning, followed by a test in few days and parent counselling is also planned. 
        <br/>
        </Typography>
      </Box>
      {/* <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
       “OPPORTUNITIES DON'T HAPPEN, YOU CREATE THEM”

<br/>
        </Typography> */}

      <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 200 : 100}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>

    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <Sidebar2025/>
             </Box>
             <Box marginBottom={4}>
               <Archive2022/>
             </Box>

    </Grid>
    </Grid> 
    </Container>
    </Main>
   
   
  );
};

export default CareerGuidance2025;